import {
  apiGetProductBuilderDetail,
  checkForMattressBuilderPermission,
  getAllProductBuilderForCheckingPermission,
  updateProductBuilderData,
} from '../../../../api/productBuilderApis';
import {
  PRODUCT_BUILDER_LOAD_ROOM_ID_DEV,
  PRODUCT_BUILDER_LOAD_ROOM_ID_PROD,
  UPLOAD_MAP_TO_FILTER_ID,
} from '../../../../config/constant/curatorConstants';
import {
  CHANGED_MAP_IDS__TEXTURE_MAP,
  MEASURE_UNIT_LABEL,
  TEXTURE_MAP_TO_TILING_TYPE,
  TEXTURE_NAME_KEY,
  TEXTURE_NAME_KEY__TEXTURE_MAP,
  TILING_KEY,
  TILING_MAP,
  TILING_TYPE,
} from '../../../../config/constant/unityConstants';
import { updateDbMaterial, updateDbProp, updateDbTexture } from '../../../../helpers/idb';
import { decimals, wait } from '../../../../helpers/jsHelper';
import { dispatcher } from '../../../../helpers/projectHelper';
import { UnityEvent, waitForEventOnce } from '../../../../helpers/unityPubSub';
import PubSub from 'pubsub-js';
import { isProductionUrl } from '../../../../helpers/urlHelper';
import { getRoomJsonFile } from '../../../../pages/admin/curator/getRoomJsonFile';
import {
  curatorActions,
  selectActiveMeasureUnitsName,
  setIndividualProjectData,
} from '../../../../redux/slicers/admin/curatorSlicer';
import {
  productBuilderActions,
  selectAddedHandleData,
  selectAddedLabelData,
  selectAddedTapeData,
  selectProductBuilderData,
  selectSelectedBottomData,
  selectSelectedHeight,
  selectSelectedSize,
  selectSelectedTopData,
  selectSelectedWallData,
  selectLayerType,
  selectAddedLayerData,
  selectAddedViewData,
  selectRoomData,
  selectAllTopData,
  selectAllBottomData,
  selectMirrorTopToggle,
  selectAllProperties,
  selectSelectionsData,
  selectButtonData,
  selectPatternList,
  selectCurrentMattressView,
  selectSizeList,
} from '../../../../redux/slicers/productBuilder/productBuilder.slicer';
import { getAppState } from '../../../../redux/store';
import {
  apiAddDefaultTexture,
  apiGet,
  apiGetTextureList,
  apiGetDefaultTexture,
  apiGetMaterialsV2,
} from '../../../../helpers/api';
import { OP_GET_ROOMS_API } from '../../../../config/constant/apiConstant';
import {
  defaultTexures,
  getDefaultTextureFromIdb,
} from '../stylesSection/PropertiesTab/useGetDefaultObjectMaps';
import { CONVERT_IN_INCHES } from '../../../../constants/projectConstants';
import { ONE_SECOND, PRODUCT_BUILDER_PROP_TYPE } from '../../../../constants/constants';
import { capitalize, isEmpty, startCase, uniqBy } from 'lodash';
import {
  selectIsAnyObjectSelected,
  selectSelectedObjectList,
  selectSelectedObjectName,
} from '../../../../redux/slicers/admin/curatorUnityObjectSlicer';
import { errorToast, successToast, warningToast } from '../../../../helpers/toastHelper';
import { openInfoDialog } from '../../../../hooks/useInfoDialogaActions';
import { getJson } from '../../../../helpers/axiosHelper';
import { paginatedProductActions } from '../../../../redux/slicers/admin/paginatedProductSlicer';
import { resetCreatedLists } from '../../../../redux/slicers/admin/paginatedRenderPreviewsSlicer';
import {
  resetDraggableProductId,
  setDraggableProductImage,
  setUnityDraggableProductData,
} from '../../../../redux/slicers/admin/curatorProductsSlicer';
import { convertTilingtypeData } from '../../../../helpers/unity/parseUnityObject';
import { THUMBNAIL_PLACEHOLDER } from '../../../../constants/assetConstants';
import { MattressPdf } from './pdf';
import { pdf } from '@react-pdf/renderer';
import { LogConsole, LogCurator } from '../../../../helpers/logEvents';
import {
  CURATOR_PRODUCT_BUILDER_ROUTE,
  RETAIL_AUTOMATION_ROUTE,
  RETAIL_AUTOMATION_ROUTE_V2,
  RETAIL_CONFIGURATOR_ROUTE,
} from '../../../../constants/routePathConstants';
import icons from '../../../../assets/icons';
import { mattressBtnClickEvents } from './userPilotEventsMattressBuilder';
import { undoRedo } from '../UndoRedo/UndoRedo';

const { ExplodedViewIcon, NormalViewIcon, CutawayViewIcon } = icons;

export const DEFAULT_INITIAL_MATTRESS_BUILDER_ROOM = {
  roomCameraInfo: {
    seq_no: 1,
    distanceToSet: 4.0354,
    fov: 18,
    horizontalFov: 27.342614992942337,
    xTransRot: 90,
    yTransRot: 180,
    zTransRot: 0,
    centerObjectxPos: 0,
    centerObjectyPos: 0.4621,
    centerObjectzPos: 0,
    isCameraCorrection: false,
    lensShiftY: 0,
    cameraHeight: 0,
    cameraRotX: 0,
    cameraRotZ: 0,
    focalLength: 74,
    isdepthOfField: false,
    selectedObjectName: '',
    blurIntensity: 0,
    xPos: 3.679,
    yPos: 0.6532,
    zPos: 4.0354,
    resoX: 1920,
    resoY: 1080,
    cameraName: 'SS Camera 1',
    isPredefinedCamera: true,
    id: '76c4b675-5993-4f96-bc1a-d8286bedcc80',
    sensor_width: 0,
    sensor_height: 0,
    canvas_width: 0,
    canvas_height: 0,
    sensorWidth: 1920,
    sesnsorHeight: 1080,
  },
  props: [
    {
      type: 'ProductBuilderRoomProp',
      indexName: '1',
      xPosition: 0,
      yPosition: 0,
      zPosition: 0,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      loadedPropType: 'None',
      modelType: 'None',
      componentType: 'Top',
    },
    {
      type: 'ProductBuilderRoomProp',
      indexName: '1',
      xPosition: 0,
      yPosition: 0,
      zPosition: 0,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      loadedPropType: 'None',
      modelType: 'None',
      componentType: 'Wall',
    },
    {
      type: 'ProductBuilderRoomProp',
      indexName: '1',
      xPosition: 0,
      yPosition: 0,
      zPosition: 0,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      loadedPropType: 'None',
      modelType: 'None',
      componentType: 'Bottom',
    },
  ],
  materialVersion: 'V3',
};

export const POSITION_DATA = [
  {
    label: 'Left',
    value: 'LeftCenter',
  },
  {
    label: 'Right',
    value: 'RightCenter',
  },
  {
    label: 'Front',
    value: 'ForwardCenter',
  },
  {
    label: 'Back',
    value: 'BackCenter',
  },
];

export const CUTAWAY_VIEW_VALUE = 'cutaway'

export const ALL_VIEWS = [
  {
    icon: ExplodedViewIcon,
    name: 'Exploded',
    value: 'exploded',
    selected: true,
    is_expand: true,
    sliderText: 'Gap between layers',
    valueForView: 0.3,
  },
  {
    icon: NormalViewIcon,
    name: 'Inner Build',
    value: 'normal',
    selected: false,
    is_expand: false,
    sliderText: '',
    valueForView: 0,
  },
  {
    icon: CutawayViewIcon,
    name: 'Cutaway View',
    value: CUTAWAY_VIEW_VALUE,
    selected: false,
    is_expand: true,
    sliderText: '',
    valueForView: 0,
    hideArrowIcon: true,
  },
  // {
  //   icon: xRayIcon,
  //   name: 'X-ray',
  //   value: 'xray',
  //   is_expand: false,
  //   sliderText: 'Transparency',
  //   valueForView: 0.7,
  // },
  // {
  //   icon: CutawayViewIcon,
  //   name: 'Cutaway View',
  //   value: 'cutaway',
  // },
];
export const OFFSET_DIAMETER_STEP = 0.01;
export const DEFAULT_STARTS_FROM = 0;
export const MAX_OFFSET_GAP = 99.999;
export const MAX_STARTS_FROM = 1;
export const DEFAULT_GAP = 10;
export const DEFAULT_GAP_WALL = 5;
export const DEFAULT_COUNT = 6;
export const DEFAULT_COUNT_WALL = 2;
export const DEFAULT_TUFT_DEPTH = 0.5;
export const DEFAULT_TUFT_WRINKLE = 0;
export const BUTTON_STEP = 1;
export const MIN_ROWS_COLUMNS = 1;
export const MAX_ROWS_COLUMNS = 30;
export const DEFAULT_OFFSET = 0;
export const DEFAULT_DIAMETER_SIZE = 1;
export const DEFAULT_BOUNDARY_GAP = 3;
export const DEFAULT_BOUNDARY_GAP_WALL_X = 1.5;
export const DEFAULT_BOUNDARY_GAP_WALL_Y = 0.8;
export const DEFAULT_MATTRESS_NAME = 'New Mattress';
export const DEFAULT_SCALE = 0;
export const DEFAULT_HEIGHT = 12;
export const MIN_SCALE = 0.001;
export const MIN_BUTTON_SCALE = 0.1;
export const MAX_BUTTON_SCALE = 3;
export const STEP = 0.001;
export const MAX_SCALE = 10;
export const MIN_POSITION = 0;
export const MAX_POSITION = 1;
export const INTERNAL_LAYER = 'internal_layer';
export const TUFTED_BUTTON = 'tufted_button';
export const DEFAULT_MATERIAL_NAME = 'Mattress Top MB2';
export const DEFAULT_MATTRESS_MATERIAL = 'DEFAULT_MATTRESS_MATERIAL';
export const DEFAULT_BOTTOM = 'Smooth Bottom';
export const DEFAULT_SIZE = 'King';
export const MINIMUM_HEIGHT = 0.5;
export const MAXIMUM_HEIGHT = 40;
export const HEIGHT_TOLERANCE = 0;
export const VIEW = {
  normal: { label: 'Inner Build', text: '' },
  exploded: { label: 'Exploded', text: 'Gap between layers' },
  cutaway: { label: 'Cutaway View', text: 'Cutaway on layers' },
  xray: { label: 'X-ray', text: 'Transparency' },
};
export const DEFAULT_VIEW = {
  view: 'exploded',
  gapexploded: 0.3,
};
export const DEFAULT_MATERIAL_FILTERS = [
  'Fabric',
  'Textile',
  // 'Cotton',
  'Cushion',
  'Cushion fabric',
  'Velvet',
];

export const SIZES = [
  // {
  //   id: 110,
  //   name: `Full (Double) – 54" x 75"`,
  //   value: 'Full',
  //   thumbnail:
  //     'https://media.imagine.io/media/public/images_mattress_builder/Full_Double_54_%2075_.png',
  //   is_enabled: true,
  //   seq_no: 110,
  //   comingSoon: true,
  // },
  // {
  //   id: 111,
  //   name: `Crib – 28" x 52"`,
  //   value: 'Crib',
  //   thumbnail: 'https://media.imagine.io/media/public/images_mattress_builder/Crib28_52_.png',
  //   is_enabled: true,
  //   seq_no: 111,
  //   comingSoon: true,
  // },
  // {
  //   id: 113,
  //   name: `Small Single – 30" x 75"`,
  //   value: 'Small Single',
  //   thumbnail:
  //     'https://media.imagine.io/media/public/images_mattress_builder/Small_Single_30__75_.png',
  //   is_enabled: true,
  //   seq_no: 113,
  //   comingSoon: true,
  // },
  // {
  //   id: 112,
  //   name: `California King – 72" x 84"`,
  //   value: 'California King',
  //   thumbnail:
  //     'https://media.imagine.io/media/public/images_mattress_builder/California_King%20_72_84_.png',
  //   is_enabled: true,
  //   seq_no: 112,
  //   comingSoon: true,
  // },
  {
    id: 114,
    name: `Olympic Queen – 66" x 80"`,
    value: 'Olympic Queen',
    thumbnail:
      'https://media.imagine.io/media/public/images_mattress_builder/Olympic_Queen_66_%2080_.png',
    is_enabled: true,
    seq_no: 114,
    comingSoon: true,
  },
  {
    id: 115,
    name: `Super King – 72" x 78"`,
    value: 'Super King',
    thumbnail:
      'https://media.imagine.io/media/public/images_mattress_builder/Super_King_72_78_.png',
    is_enabled: true,
    seq_no: 115,
    comingSoon: true,
  },
  {
    id: 116,
    name: `Wyoming King – 84" x 84"`,
    value: 'Wyoming King',
    thumbnail:
      'https://media.imagine.io/media/public/images_mattress_builder/Wyoming_King84_84_.png',
    is_enabled: true,
    seq_no: 116,
    comingSoon: true,
  },
  {
    id: 117,
    name: `Texas King – 80" x 98"`,
    value: 'Texas King',
    thumbnail:
      'https://media.imagine.io/media/public/images_mattress_builder/Texas_King_80_%2098_.png',
    is_enabled: true,
    seq_no: 117,
    comingSoon: true,
  },
  {
    id: 118,
    name: `Alaskan King – 108" x 108" `,
    value: 'Alaskan King',
    thumbnail:
      'https://media.imagine.io/media/public/images_mattress_builder/Alaskan_King108_108_.png',
    is_enabled: true,
    seq_no: 117,
    comingSoon: true,
  },
];

export const changeToCM = (val) => {
  const measureUnits = selectActiveMeasureUnitsName(getAppState());
  let multiplayFactor = 1;
  if (MEASURE_UNIT_LABEL[measureUnits] === 'feet') {
    multiplayFactor = 30.48;
  } else if (MEASURE_UNIT_LABEL[measureUnits] === 'inches') {
    multiplayFactor = 2.54;
  } else if (MEASURE_UNIT_LABEL[measureUnits] === 'meter') {
    multiplayFactor = 100;
  }
  return val * multiplayFactor;
};

export const isMattressBuilderPage = () =>
  window.location.pathname.includes(CURATOR_PRODUCT_BUILDER_ROUTE.replace(':id', ''));

export const isRetailAutomationPage = () =>
  window.location.pathname.includes(RETAIL_AUTOMATION_ROUTE_V2); // RETAIL_AUTOMATION_ROUTE

export const isRetailConfiguratorPage = () =>
  window.location.pathname.includes(RETAIL_CONFIGURATOR_ROUTE);

export const getOtherValues = (data) => {
  const obj = {};
  if (data?.positionX) {
    obj['positionX'] = data.positionX;
  }
  if (data?.positionY) {
    obj['positionY'] = data.positionY;
  }
  if (data?.rotation) {
    obj['rotation'] = data.rotation;
  }
  if (data?.height) {
    obj['height'] = data.height;
  }
  if (data?.width) {
    obj['width'] = data.width;
  }
  if (data?.displacementIntensity) {
    obj['displacementIntensity'] = data.displacementIntensity;
  }
  if (data?.positionXGusset) {
    obj['positionXGusset'] = data.positionXGusset;
  }
  if (data?.positionYGusset) {
    obj['positionYGusset'] = data.positionYGusset;
  }
  if (data?.rotationGusset) {
    obj['rotationGusset'] = data.rotationGusset;
  }
  if (data?.heightValueGusset) {
    obj['heightValueGusset'] = data.heightValueGusset;
  }
  if (data?.widthValueGusset) {
    obj['widthValueGusset'] = data.widthValueGusset;
  }
  if (data?.displacementIntensityGusset) {
    obj['displacementIntensityGusset'] = data.displacementIntensityGusset;
  }
  return obj;
};

export const convertToPdfFormat = (data) => {
  const selectedSize = selectSelectedSize(getAppState());
  const selectedHeight = selectSelectedHeight(getAppState());
  const measureUnits = selectActiveMeasureUnitsName(getAppState());
  const allTopData = selectAllTopData(getAppState());
  const allBottomData = selectAllBottomData(getAppState());
  const layerData = selectAddedLayerData(getAppState());
  const selectedViewData = selectAddedViewData(getAppState());
  const selectedWall = selectSelectedWallData(getAppState());
  const tapeData = selectAddedTapeData(getAppState());
  const labelData = selectAddedLabelData(getAppState());
  const handleData = selectAddedHandleData(getAppState());
  const buttonData = selectButtonData(getAppState());
  const topButtons = buttonData[PRODUCT_BUILDER_PROP_TYPE.TOP];
  const wallButtons = buttonData[PRODUCT_BUILDER_PROP_TYPE.WALL];

  return {
    size: selectedSize?.name || 'NA',
    height: selectedHeight?.name || 'NA',
    wall: selectedWall,
    tape: tapeData || [],
    label: labelData,
    handle: handleData,
    topData: allTopData,
    bottomData: allBottomData,
    measureUnits: MEASURE_UNIT_LABEL[measureUnits],
    layers: layerData,
    view: selectedViewData,
    topButtons,
    wallButtons,
  };
};

export const getSelectedDataAllTabs = () => {
  const selectedSize = selectSelectedSize(getAppState());
  const selectedHeight = selectSelectedHeight(getAppState());
  const selectedTop = selectSelectedTopData(getAppState());
  const selectedWall = selectSelectedWallData(getAppState());
  const selectedBottom = selectSelectedBottomData(getAppState());
  const selectedTapeData = selectAddedTapeData(getAppState());
  const selectedLabelData = selectAddedLabelData(getAppState());
  const selectedHandleData = selectAddedHandleData(getAppState());
  const layerType = selectLayerType(getAppState());
  const selectedLayerData = selectAddedLayerData(getAppState());
  const selectedViewData = selectAddedViewData(getAppState());
  const allTopData = selectAllTopData(getAppState());
  const allBottomData = selectAllBottomData(getAppState());
  const mirrorTopToggle = selectMirrorTopToggle(getAppState());
  return {
    size: selectedSize?.value,
    height: selectedHeight?.value,
    top: {
      patternId: selectedTop?.patternData?.id,
      patternName: selectedTop?.patternData?.name || '',
      gussetPatternId: selectedTop?.gussetPatternData?.id,
      gussetPatternName: selectedTop?.gussetPatternData?.name || '',
      topId: selectedTop?.topData?.id,
      topName: selectedTop?.topData?.name,
      ...getOtherValues(selectedTop),
    },
    bottom: {
      patternId: selectedBottom?.patternData?.id,
      patternName: selectedBottom?.patternData?.name || '',
      gussetPatternId: selectedBottom?.gussetPatternData?.id,
      gussetPatternName: selectedBottom?.gussetPatternData?.name || '',
      bottomId: selectedBottom?.bottomData?.id,
      bottomName: selectedBottom?.bottomData?.name,
      ...getOtherValues(selectedBottom),
    },
    wall: {
      patternId: selectedWall?.patternData?.id,
      patternName: selectedWall?.patternData?.name || '',
      wallId: selectedWall?.wallData?.id,
      wallName: selectedWall?.wallData?.name,
      ...getOtherValues(selectedWall),
    },
    tape: selectedTapeData,
    label: selectedLabelData,
    handle: selectedHandleData,
    layerType: layerType,
    layer: selectedLayerData,
    view: selectedViewData,
    allTopData: allTopData,
    allBottomData: allBottomData,
    mirrorTopToggle,
  };
};

export const updateRoomJson = async ({
  delay = false,
  getProjectThumbnail,
  id,
  reason = '',
  isUpdate = true,
}) => {
  console.warn(reason);
  const productBuilderData = selectProductBuilderData(getAppState());
  if (delay) {
    await wait(ONE_SECOND);
  }
  if (productBuilderData?.id) {
    const payload = {
      id: id || productBuilderData?.id,
    };
    const roomJson = await getRoomJsonFile();
    const selectedData = getSelectedDataAllTabs();
    const roomInfo = {
      roomData: roomJson?.raw,
      selectionsData: selectedData,
    };

    // keeping json data in redux instead of fetching each time when required
    const builderData = selectProductBuilderData(getAppState());
    dispatcher(
      productBuilderActions.setProductBuilderData({
        ...builderData,
        data: {
          ...builderData?.json_file,
          json_data: roomInfo,
        },
      })
    );
    const json_data = JSON.stringify(roomInfo);
    const roomJsonFileBlob = new Blob([json_data], { type: 'application/json' });
    const roomFile = new File([roomJsonFileBlob], `file_${productBuilderData.id}`);
    payload['file'] = roomFile;
    if (getProjectThumbnail) {
      const thumbnail = await getProjectThumbnail();
      const roomThumb = new File([thumbnail], `thumbnail_${productBuilderData.id}`);
      payload['thumbnail'] = roomThumb;
    }
    if (payload.file || payload.thumbnail) {
      await dispatcher(updateProductBuilderData(payload, isUpdate));
    } else dispatcher(productBuilderActions.setSaveBuilderProjectLoading(false));
  }
};

export const updateProductBuilderDataRedux = (data) => {
  dispatcher(setIndividualProjectData(data));
  dispatcher(productBuilderActions.setProductBuilderData(data));

  // // TODO: need to check
  // if (data?.data?.json_data?.selectionsData?.layer){
  //   dispatcher(productBuilderActions.setAddedLayerData(data?.data?.json_data?.selectionsData?.layer));
  // }
};

export const getProductBuilderJson = async ({ id = null, data = null, setLoading }) => {
  if (!data) return null; // or handle the case where data is null
  setLoading?.(true);

  // If json_data is available in data, return it and set loading to false
  if (data?.json_data) {
    setLoading?.(false);
    return data?.json_data;
  }

  try {
    // If json_file is available in data, fetch the JSON file and set loading to false
    const json = data?.json_file ? await getJson(data?.json_file) : null;
    setLoading?.(false);
    return json;
  } catch (error) {
    // If there's an error, fetch product details using the provided id & then get the JSON file
    const response = await apiGetProductBuilderDetail(id);
    const json = await getJson(response?.data?.json_file);
    setLoading?.(false);
    return json;
  }
};

export const callUnityEventChangeType = async (data, type, objectName) => {
  const productDbData = await updateDbProp(data);
  const selectedSize = selectSelectedSize(getAppState());
  const selectedHeight = selectSelectedHeight(getAppState());
  const obj = {
    type: 'ProductBuilderReplaceProp',
    id: data.id,
    componentType: type,
    propName: data.name,
    locationUrl: productDbData?.file || data.product_file,
    productProperty: data?.product_property,
  };
  const dataToPass = {
    props: [obj],
    height: selectedHeight?.value,
    uniqueIdentifierForProducts: selectedSize?.value?.toLowerCase(),
    operationType: 'Modify',
  };
  if (objectName) {
    dataToPass.objectNameToModify = objectName;
  }
  window.roomModule.ChangeProductComponentReceiver(dataToPass);
};

export const callUnityEventAddComponent = async (props) => {
  const {
    data,
    str,
    type,
    sideLoc,
    opType,
    internalLayerView,
    allowHeight,
    isMirrorTopOverBottom,
    objectNameToModify,
    placementType,
    materialDataModel,
    objectNameToDuplicate,
    valueForView,
    tuftedButtonConfiguration,
  } = props;
  const isMirror = 'isMirrorTopOverBottom' in props;
  const selectedHeight = selectSelectedHeight(getAppState());
  const allProps = [];
  for (let i = 0; i < data?.length; i++) {
    const processData = data[i];
    const productDbData = await updateDbProp(processData);
    const obj = {
      type: 'ProductBuilderReplaceProp',
      id: processData.id,
      componentType: processData?.type || type,
      propName: processData.name,
      locationUrl: productDbData?.file || processData.product_file,
      productProperty: processData?.product_property,
    };
    if (processData?.linkedObjectName) {
      obj.linkedObjectName = processData?.linkedObjectName;
    }
    allProps.push(obj);
  }
  const dataToPass = {
    props: allProps,
    operationType: opType || 'Add',
    sideLocation: sideLoc?.value || sideLoc || '',
  };
  if (internalLayerView) {
    dataToPass['internalLayerView'] = internalLayerView;
    dataToPass['height'] = selectedHeight?.value;
  } else {
    if (allowHeight) {
      dataToPass['height'] = selectedHeight?.value;
    }
  }
  if (isMirror) {
    dataToPass.isMirrorTopOverBottom = isMirrorTopOverBottom;
  }
  if ('objectNameToModify' in props) {
    dataToPass.objectNameToModify = objectNameToModify;
  }
  if (placementType) {
    dataToPass.placementType = placementType;
  }
  if (materialDataModel) {
    dataToPass.materialDataModel = materialDataModel;
  }
  if (objectNameToDuplicate) {
    dataToPass.objectNameToDuplicate = objectNameToDuplicate;
  }
  if ('valueForView' in props) {
    dataToPass.valueForView = valueForView;
  }
  if (tuftedButtonConfiguration) {
    dataToPass.tuftedButtonConfiguration = tuftedButtonConfiguration;
  }
  const unityFunction = placementType
    ? window.roomModule.AutomaticPlacementReceiever
    : isMirror
    ? window.roomModule.MirrorTopToBottomReceiver
    : tuftedButtonConfiguration
    ? opType === 'Add'
      ? window.productBuilderModule.AddButtonReceiver
      : opType === 'Modify'
      ? window.productBuilderModule.ChangeProductComponentReceiver
      : window.productBuilderModule.ChangeButtonConfiguration
    : window.roomModule.AddProductComponentReceiver;
  unityFunction(dataToPass);
};

export const callUnityEventModifyProperty = (
  value,
  type,
  objName,
  sideLocation,
  componentType,
  isLayer,
  arrangeTuftButton = null
) => {
  const selectedHeight = selectSelectedHeight(getAppState());
  const dataToPass = {
    value: value?.name ? value?.value : value || 0,
    transformParamaterType: type,
    objectName: objName,
    sideLocation: sideLocation,
    componentType: componentType,
    ...(arrangeTuftButton ? { arrangeTuftButton:true } : {})
  };
  if (isLayer) {
    const layer = selectAddedViewData(getAppState());
    const internalLayerView = layer?.view?.charAt(0)?.toUpperCase() + layer?.view?.slice(1);
    const valueForView =
      layer?.view === 'exploded'
        ? (layer?.[`gap${layer?.view}`] || 0) * 0.35
        : layer?.[`gap${layer?.view}`] || 0;
    dataToPass['internalLayerView'] = internalLayerView;
    dataToPass['height'] = selectedHeight?.value;
    dataToPass['valueForView'] = valueForView;
  }
  window.roomModule.ModifyComponentTransformReceiver(dataToPass);
};

export const deleteComponentType = (data, isLayer, allowHeight = false) => {
  const selectedHeight = selectSelectedHeight(getAppState());
  const payload = { objectName: data };
  if (isLayer) {
    const layer = selectAddedViewData(getAppState());
    const internalLayerView = layer?.view?.charAt(0)?.toUpperCase() + layer?.view?.slice(1);
    const valueForView =
      layer?.view === 'exploded'
        ? (layer?.[`gap${layer?.view}`] || 0) * 0.35
        : layer?.[`gap${layer?.view}`] || 0;
    payload['internalLayerView'] = internalLayerView;
    payload['height'] = selectedHeight?.value;
    payload['valueForView'] = valueForView;
  } else {
    if (allowHeight) {
      payload['height'] = selectedHeight?.value;
    }
  }
  window.roomModule.DeleteProductComponentReceiver(payload);
};

export const getFilteredComponent = async (type) => {
  const allComponentTypes = await waitForEventOnce(UnityEvent.OnReceiveCurrentComponents, () =>
    window.roomModule.GetCurrentComponentsReceiver()
  );
  const filteredComponent = type
    ? allComponentTypes?.filter((data) => data.componentType === startCase(type).replace(/\s/g, ''))
    : allComponentTypes;
  LogCurator('filteredComponent', filteredComponent);
  return filteredComponent;
};

export const callUnityEventModifySide = (value, objName, type, arrangeTuftButton = null) => {
  const dataToPass = {
    sideLocation: value?.value || value || 0,
    objectName: objName,
    componentType: type,
    ...(arrangeTuftButton ? { arrangeTuftButton:true } : {})
  };
  window.roomModule.ChangeComponentSideReceiver(dataToPass);
};

export const selectUnityObject = ({
  mainController,
  name,
  isReceiveSelectedObjectInfo = true,
  selectedObjects = [],
}) => {
  mainController.SelectProductObjectReceiver(
    selectedObjects?.length
      ? selectedObjects
      : [
          {
            objectName: name,
            clickedObjectName: name,
            ObjectSelectionMode: 'Style',
            isReceiveSelectedObjectInfo,
          },
        ]
  );
};

export const callUnityEventModifyComponent = async (props) => {
  const { data, type, sideLoc, opType, objName, height, layer, valueForView } = props;
  const allProps = [];
  const selectedHeight = selectSelectedHeight(getAppState());
  for (let i = 0; i < data?.length; i++) {
    const processData = data[i];
    const productDbData = await updateDbProp(processData);
    const obj = {
      type: 'ProductBuilderReplaceProp',
      id: processData.id,
      componentType: type,
      propName: processData.name,
      locationUrl: productDbData?.file || processData.product_file,
      productProperty: processData?.product_property,
    };
    allProps.push(obj);
  }
  const dataToPass = {
    props: allProps,
    operationType: opType || 'Add',
    sideLocation: sideLoc?.value || sideLoc || '',
    objectName: objName,
    height: height?.toString() || selectedHeight?.value,
  };
  if (layer) {
    dataToPass['internalLayerView'] = layer;
  }
  if ('valueForView' in props) {
    dataToPass.valueForView = valueForView;
  }
  window.roomModule.ModifyComponentReceiver(dataToPass);
};

export const removeDisplacement = () => {
  window.roomModule.UseCustomDisplacementMapToggleReceiver(false);
};

export const changeHeightValue = (data) => {
  window.roomModule.ChangeHeightProductReceiver(data);
};

export const changeIntensity = (data) => {
  window.roomModule.OnUpdateDisplacementValueReceiver(data);
};

export const roomIdForMattressBuilder = async ({ organisationId }) => {
  await getMattressBuilderRoomId({ organisationId });
  const roomData = selectRoomData(getAppState());
  if (roomData?.id) {
    return roomData.id;
  }
  const isProdUrlUsed = process.env.REACT_APP_API_BASE_URL.includes('prod');
  if (isProductionUrl || isProdUrlUsed) {
    return PRODUCT_BUILDER_LOAD_ROOM_ID_PROD;
  }
  return PRODUCT_BUILDER_LOAD_ROOM_ID_DEV;
};

export const changeMattressView = ({ type, gap, isValueForViewChanged, isViewChangeUIClicked }) => {
  // const currentMattressView = selectCurrentMattressView(getAppState());

  // If already in current view do not trigger
  // Doing this now for cutaway as other working depends on it
  // if (type === "Cutaway" && currentMattressView === "Cutaway") return

  const selectedHeight = selectSelectedHeight(getAppState());
  const payload = {
    internalLayerView: type,
    height: selectedHeight?.value || DEFAULT_HEIGHT,
  };
  // if (type === 'Exploded') {
  payload['valueForView'] = gap;
  // }
  if (isValueForViewChanged) {
    payload['isValueForViewChanged'] = isValueForViewChanged;
  }
  // TO DO: Commenting this as it is causing issues
  // if (isViewChangeUIClicked) {
  //   payload['isViewChangeUIClicked'] = isViewChangeUIClicked;
  // }
  window.roomModule.ToggleProductBuilderInternalViewReceiver(payload);
  dispatcher(productBuilderActions.setCurrentMattressView(type));
};

export const changeLayerSequence = (payloadPassed) => {
  const selectedHeight = selectSelectedHeight(getAppState());
  const payload = {
    ...payloadPassed,
    height: selectedHeight?.value || DEFAULT_HEIGHT,
  };
  window.roomModule.ChangeLayerSequenceReceiver(payload);
};

export const toggleLock = (payloadPassed) => {
  const payload = {
    ...payloadPassed,
  };
  window.roomModule.ToggleLockLayerReceiver(payload);
};

export const highlightProductBuilderObjectReceiver = (data) => {
  window.roomModule.HighlightProductBuilderObjectReceiver(data);
};

export const changeCameraNearClipPlane = (data) => {
  window.roomModule.ChangeCameraNearClipPlane(data);
};

export const snapButtonsToParentObject = () => {
  window.productBuilderModule.SnapButtonsToParentObject();
};

export const checkHasMattressBuilderPermission = async (callback) => {
  const response = await checkForMattressBuilderPermission();
  if (response?.status) {
    const permission = Boolean(response?.data?.has_active_mattress_permission);
    callback?.(permission);
    if (permission) {
      return true;
    }
    const data = await getAllProductBuilderForCheckingPermission();
    if (data?.length) {
      return true;
    }
    return false;
  }
  return false;
};

export const getMattressBuilderRoomId = async ({ organisationId }) => {
  const roomData = selectRoomData(getAppState());
  if (!roomData) {
    const url = `${OP_GET_ROOMS_API}?is_mattress_builder_template=true`;
    const data = await apiGet(url);
    const results = data?.results || [];
    if (results.length) {
      const roomData = results?.[0];
      dispatcher(productBuilderActions.setRoomData(roomData));
    }
  }
};

export const convertUnitsToInches = (val) => {
  const num = val * CONVERT_IN_INCHES;
  return num;
};

export const convertInchesToUnits = (val) => {
  const num = val / CONVERT_IN_INCHES;
  return num;
};

export const getValueInInches = (value) => {
  const newValue = convertUnitsToInches(value);
  return decimals(newValue, 3);
};

export const hideSizeFromName = ({ name = '' } = {}) => {
  const sizeList = selectSizeList(getAppState());
  const sizeNames = sizeList.map((ins) => ins?.value).filter((val) => val);
  if (name && sizeNames?.length) {
    // Escape regex special characters
    const escaped = sizeNames.map((w) => w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
    // Join into one alternation, sorted by length to ensure longer phrases win
    const regex = new RegExp(
      `\\b(?:${escaped.sort((a, b) => b.length - a.length).join('|')})\\b`,
      'gi'
    );
    return name.replace(regex, '').replace(/\s+/g, ' ').trim();
  }
  return name;
};

const INCH_PATTERN = /(\d+(?:\.\d+)?)\s*(?:"|inches\b|inch\b|in\b)/gi;

const extractInchValues = (name = '') => {
  if (!name) return [];
  return [...name.matchAll(INCH_PATTERN)].map((m) => parseFloat(m[1]));
};

const formatCmList = (inches) => inches.map((inch) => `${Math.round(inch * 2.54)} cm`).join(' x ');

export const appendCmConversionToName = (name = '') => {
  const inches = extractInchValues(name);
  if (!inches.length) return name;
  return `${name} (${formatCmList(inches)})`;
};

export const getCmConversionFromName = (name = '', fallbackInches = null) => {
  let inches = extractInchValues(name);
  if (!inches.length && fallbackInches != null && !Number.isNaN(parseFloat(fallbackInches))) {
    inches = [parseFloat(fallbackInches)];
  }
  if (!inches.length) return '';
  return `(${formatCmList(inches)})`;
};

export const splitSizeNameForDisplay = (name = '') => {
  if (!name) return { label: '', dimensions: '' };
  const trimmed = name.trim();
  const separatorMatch = trimmed.match(/^(.*?)\s*[–-]\s*(.+)$/);
  if (separatorMatch) {
    return { label: separatorMatch[1].trim(), dimensions: separatorMatch[2].trim() };
  }
  const firstInch = trimmed.search(INCH_PATTERN);
  INCH_PATTERN.lastIndex = 0;
  if (firstInch > 0) {
    return {
      label: trimmed.slice(0, firstInch).trim(),
      dimensions: trimmed.slice(firstInch).trim(),
    };
  }
  return { label: trimmed, dimensions: '' };
};

export const getDisplacementProperties = (object) => {
  const mapData = object?.tilingOffsetValue?.[TILING_KEY._DisplacementMap];
  const { width, height, x, y, rotation } = convertTilingtypeData(mapData, 3);
  return {
    width,
    height,
    positionX: x,
    positionY: y,
    rotation: rotation,
    displacementIntensity: decimals(object?.displacementIntensity, 3),
  };
};

export const clearDefaultTexturesFromData = () => {
  const keys = Object.keys(defaultTexures);
  keys.forEach((key) => {
    delete defaultTexures?.[key];
  });
};

export const roundToHalf = (num) => {
  return Math.ceil(num * 2) / 2;
};

export const getMinimumAvailableHeight = async () => {
  const allComponents = await getFilteredComponent();
  const topBottomComponents = allComponents.filter(
    (ins) =>
      ins.componentType === capitalize(PRODUCT_BUILDER_PROP_TYPE.TOP) ||
      ins.componentType === capitalize(PRODUCT_BUILDER_PROP_TYPE.BOTTOM)
  );
  let calculatedHeight = topBottomComponents.reduce(
    (sum, item) => sum + item.height * CONVERT_IN_INCHES,
    0
  );
  calculatedHeight = calculatedHeight + 1;
  return roundToHalf(calculatedHeight);
};

export const handleUserComponentConfirmationReceiver = (data) => {
  window.roomModule.HandleUserComponentConfirmationReceiver(data);
};

export const deleteComponentOnKeyPressReceiver = (data) => {
  const selectedHeight = selectSelectedHeight(getAppState());
  const objectNames = {
    productBuilderPropModels: data,
    height: selectedHeight?.value || DEFAULT_HEIGHT,
  };
  window.roomModule.DeleteComponentOnKeyPressReceiver(objectNames);
};

export const getUniqueId = (arrayData = [] , keyName) => {
  const uniqueParentObjects = [...new Set(arrayData.map(item => item?.[keyName]))];
  return uniqueParentObjects
}

export const getMatchedTuftedObjectId = (mainArray = [] , idArrayToMatch = []) => {
  const matchedObjectInfo = [];
  const matchedObjectSideLocation = [];
  const idSet = new Set(idArrayToMatch);
   for (const obj of mainArray) {
  if (obj.componentType === "TuftedButton" && idSet.has(obj.objectName)) {
    matchedObjectInfo.push(obj.tuftButtonParentObjectName);
    obj?.tuftButtonSideLocation && matchedObjectSideLocation.push(obj?.tuftButtonSideLocation)
  }
}
return {
  parentObjectIds: [...new Set(matchedObjectInfo)],
  tuftButtonSideLocation: [...new Set(matchedObjectSideLocation)]
}
}

export const getTuftButtonConfiguratorData = ({objects, allComponents}) => {
  const parentObjectIds = getUniqueId(objects, 'parentObjectName')
  const {parentObjectIds: uniqueComponentIds , tuftButtonSideLocation } =  getMatchedTuftedObjectId(allComponents, parentObjectIds)
  let topTuftButtonConfigurator = null, wallTuftButtonConfigurator = null , internalLayerPayload = null; 
  const isLayerDelete = objects.find((val) => val?.styleObjectDatas?.[0]?.type === 'InternalLayer');
  const layerView = selectAddedViewData(getAppState());
  const internalLayerView = layerView?.view?.charAt(0)?.toUpperCase() + layerView?.view?.slice(1);
  const valueForView =
      layerView?.view === 'exploded'
        ? (layerView?.[`gap${layerView?.view}`] || 0) * 0.35
        : layerView?.[`gap${layerView?.view}`] || 0;
  if(isLayerDelete){
    internalLayerPayload = {
      internalLayerView: internalLayerView || 'Exploded',
      valueForView: valueForView || 0,
    };
  }
  if(uniqueComponentIds?.length){
      uniqueComponentIds.forEach((objNameId) => {
        const tuftedButtonConfigData = allComponents.find(({objectName})=> objectName === objNameId)
        if(tuftedButtonConfigData?.componentType?.toLowerCase() === PRODUCT_BUILDER_PROP_TYPE.TOP){
          topTuftButtonConfigurator = tuftedButtonConfigData
        }
        if(tuftedButtonConfigData?.componentType?.toLowerCase()  === PRODUCT_BUILDER_PROP_TYPE.WALL){
          wallTuftButtonConfigurator = tuftedButtonConfigData;  
        }
      })
  }
  const finalButtonConfigData = []
  if(topTuftButtonConfigurator){
    topTuftButtonConfigurator?.tuftedButtonConfigurations?.[0] && finalButtonConfigData.push(topTuftButtonConfigurator?.tuftedButtonConfigurations?.[0])
  }

  if(wallTuftButtonConfigurator){
    wallTuftButtonConfigurator?.tuftedButtonConfigurations?.map((wallConfig) => {
      if(tuftButtonSideLocation.includes(wallConfig?.sideLocation)){
        finalButtonConfigData.push(wallConfig)
      }
    })
  }
  const finalData = {
    topTuftButtonConfigurator,
    wallTuftButtonConfigurator,
    tuftButtonSideLocation,
    finalButtonConfigData,
    internalLayerPayload,
    layerView,
    internalLayerView,
    valueForView,
  };
  return finalData
}

export const deleteProductBuilderObjects = async () => {
  const objects = selectSelectedObjectList(getAppState());
  const allComponents = await getFilteredComponent();
  if (!objects?.length) {
    errorToast('Please select object');
    return;
  }
  const filterTuftData = getTuftButtonConfiguratorData({objects, allComponents})
  let filteredObjectNames = [];
  allComponents?.map((object) => {
    const isTuftButton = object?.componentType === 'TuftedButton';
    const findValue = isTuftButton ? objects.find((obj) => obj?.objectName === object?.objectName) : objects.find((obj) => obj?.parentObjectName === object?.objectName) 
    if (findValue) {
      if (isTuftButton) {
        if (object?.tuftedButtonType === 'Wall') {
          filteredObjectNames.push({
            objectName: object?.objectName,
            parentTuftObjectName: object?.tuftButtonParentObjectName,
            tuftButtonSideLocation: object?.tuftButtonSideLocation,
          });
        } else {
          filteredObjectNames.push({
            objectName: object?.objectName,
            parentTuftObjectName: object?.tuftButtonParentObjectName,
            tuftButtonSideLocation: object?.tuftButtonSideLocation,
          });
        }
      } else {
        filteredObjectNames.push({ objectName: object?.objectName });
      }
    }
  });
  const topObjects = objects.filter((val) =>
    val?.styleObjectDatas?.find((ins) => ins?.type?.toLowerCase() === PRODUCT_BUILDER_PROP_TYPE.TOP)
  );
  const bottomObjects = objects.filter((val) =>
    val?.styleObjectDatas?.find(
      (ins) => ins?.type?.toLowerCase() === PRODUCT_BUILDER_PROP_TYPE.BOTTOM
    )
  );
  const isWallPresent = objects.some((val) =>
    val?.styleObjectDatas?.find(
      (ins) => ins?.type?.toLowerCase() === PRODUCT_BUILDER_PROP_TYPE.WALL
    )
  );
  let allowDelete = true;
  let topAndBottomObjectAvailable = false;
  if (topObjects?.length) {
    const tops = allComponents.filter(
      (ins) => ins.componentType === capitalize(PRODUCT_BUILDER_PROP_TYPE.TOP)
    );
    topAndBottomObjectAvailable = true
    if (tops?.length === 1 || topObjects?.length > 1) {
      allowDelete = false;
    }
  }
  if (bottomObjects?.length) {
    const bottoms = allComponents.filter(
      (ins) => ins.componentType === capitalize(PRODUCT_BUILDER_PROP_TYPE.BOTTOM)
    );
    topAndBottomObjectAvailable = true
    if (bottoms?.length === 1 || bottomObjects?.length > 1) {
      allowDelete = false;
    }
  }
  if (isWallPresent) {
    allowDelete = false;
  }
  if (!allowDelete) {
    warningToast(
      'The selected asset cannot be deleted. Please select a different variant from the list.'
    );
    return;
  }
  openInfoDialog({
    title: `Are you sure you want to delete ${objects?.length > 1 ? 'these' : 'this'} item${
      objects?.length > 1 ? 's' : ''
    }?`,
    cancelButtonText: 'Cancel',
    buttonText: 'Confirm',
    onButtonClick: async () => {
      // Store objects data before deletion for undo/redo
      const objectsData = objects.map((object) => ({
        objectName: object?.parentObjectName,
      }));

      const objectNames = objects.map((object) => ({
        objectName: object?.parentObjectName,
      }));
      deleteComponentOnKeyPressReceiver(objectNames);
      // Add undo/redo action for multiple deletions using generic productBuilder action
      if (objectsData.length > 0) {
        undoRedo.productBuilder?.addMultiDeleteAction({
          filteredObjectNames,
          filterTuftData,
          topAndBottomObjectAvailable,
          objectsData,
          refreshCallback: async () => {
            dispatcher(productBuilderActions.setChangedValue('deleteUndoRedoMenu'));
          },
        });
      }
      successToast(`${objects?.length > 1 ? 'Items' : 'Item'} deleted successfully`);
    },
  });
};

export const isDeletedObjectPresent = ({ deletedData = [], storedData = [] } = {}) => {
  const isPresent = storedData.some((val) => deletedData.includes(val.objectName));
  return isPresent;
};

export const getDefaultMaterial = async () => {
  // TO DO: Commenting this as it was causing issue while downloading the material in unity
  // let defaultMaterial = getLocalStorage(DEFAULT_MATTRESS_MATERIAL);
  // let materials = null;
  // if (defaultMaterial) {
  //   defaultMaterial = JSON.parse(defaultMaterial);
  // }
  // if (
  //   defaultMaterial?.name === DEFAULT_MATERIAL_NAME &&
  //   defaultMaterial?.is_mattress_default_material
  // ) {
  //   materials = {
  //     results: [defaultMaterial],
  //   };
  // }
  const materials = await apiGetMaterialsV2({
    query: `is_mattress_default_material=true`,
    page: 1,
  });
  if (materials?.results?.length) {
    const material = materials?.results[0];
    const materialDbData = await updateDbMaterial(material);
    // if (!defaultMaterial) {
    //   setLocalStorage(DEFAULT_MATTRESS_MATERIAL, JSON.stringify(material));
    // }
    const materialObj = {
      id: materialDbData?.id,
      materialUrl: materialDbData?.file || material.material_image,
      isGlassMaterial: false,
      isConfigurator: false,
    };
    return materialObj;
  }
  return {};
};

export const getLoadingText = (message) => {
  if (!message) {
    return '';
  }
  if (message.includes('assets')) {
    return 'Setting up your scene';
  }
  if (message.includes('materials')) {
    return 'Bringing your design to life';
  }
  return 'Loading components';
};

export const getLoadedProjectId = () => {
  const number = Math.floor(10000 + Math.random() * 90000);
  return number;
};

export const storeDefaultTextures = async ({
  materialModule,
  // productBuilderModule,
  // objectName,
  objects,
}) => {
  // let allObjects = await waitForEventOnce(
  //   UnityEvent.OnReceiveMaterialPropertiesofGivenObject,
  //   () => {
  //     materialModule.SendMaterialPropertiesByObjectNameReceiver(objectName);
  //   }
  // );
  const allObjects = objects.filter((object) => !object?.loadedMaterialId);
  const texturesData = allObjects.map((object) => {
    const textureNameList = [
      object.diffuseName,
      object.normalMapName,
      object.aoMapName,
      object.roughnessMapName,
      object.metallicMapName,
      object.transparencyMapName,
    ].filter(Boolean);
    return {
      textureNameList,
      objectName: object.objectName,
      materialId: object.loadedMaterialId,
      copiedObject: object,
    };
  });
  let dataForBase64 = [];
  const storedDefaultTextures = Object.values(window.defaultTexures);
  texturesData.map(({ textureNameList, objectName }) => {
    textureNameList.map((texture) => {
      const isStored = storedDefaultTextures.find(
        (ins) => ins?.imageUrl && ins?.textureName === texture
      );
      if (!isStored) {
        dataForBase64.push({
          textureName: texture,
          objectName,
        });
      }
    });
  });
  dataForBase64 = uniqBy(dataForBase64, 'textureName');
  if (dataForBase64.length) {
    materialModule.GetBase64DataUsingTextureName(dataForBase64);
    await waitForEventOnce(UnityEvent.AllImagesOfObjectProcessedForProductBuilder);
  }
  // const storedTextures = await Promise.all(
  //   texturesData.map(async ({ copiedObject }) => {
  //     const texture = await getAndStoreTextureInDb({ copiedObject });
  //     return texture;
  //   })
  // );
  // const defaultTextureDatas = storedTextures.flat();
  // if (defaultTextureDatas.length) {
  // await waitForEventOnce(UnityEvent.OnDefaultTextureApplyCompleted, () => {
  //   productBuilderModule.ApplyDefaultTextureDataForProductBuilder({ defaultTextureDatas });
  // });
  // }
  // return defaultTextureDatas;
};

export const getAndStoreTextureInDb = async ({ copiedObject }) => {
  const defaultTextureNameKeys = Object.values(TEXTURE_NAME_KEY);
  const { objectName } = copiedObject;
  const textureList = await Promise.all(
    defaultTextureNameKeys.map(async (textureNameKey) => {
      const textureName = copiedObject[textureNameKey];
      if (!textureName) return;
      const textureType = TEXTURE_NAME_KEY__TEXTURE_MAP[textureNameKey];
      const tilingType = TEXTURE_MAP_TO_TILING_TYPE[textureType];
      const mapType = TILING_MAP[tilingType];
      const idKey = CHANGED_MAP_IDS__TEXTURE_MAP[textureType];
      if (copiedObject.changedMapsPath[idKey]) return;
      const defaultTexture = await getDefaultTextureFromIdb({
        textureName,
      });
      const { file } = defaultTexture;
      const defaultTextureDataList = await apiGetDefaultTexture({
        name: textureName,
      });
      const defaultTextureData = defaultTextureDataList?.results?.[0];
      let texture;
      if (defaultTextureData) {
        texture = await updateDbTexture(defaultTextureData);
      } else {
        const uploadedTexture = await apiAddDefaultTexture({
          name: textureName,
          file,
        });
        if (!uploadedTexture?.data?.id) {
          console.error('Texture not found');
          return;
        }
        texture = await updateDbTexture(uploadedTexture.data);
      }
      return {
        mapType,
        textureId: texture.id,
        textureName: texture.name,
        textureVersion: texture.version,
        objectName,
      };
    })
  );
  const filteredTextureList = textureList.filter(Boolean);
  return filteredTextureList;
};

export const resetAllStates = () => {
  dispatcher(productBuilderActions.resetState());
  dispatcher(resetCreatedLists());
  dispatcher(curatorActions.resetState());
  dispatcher(paginatedProductActions.resetProgress()); // resetting loading progress state
  dispatcher(resetDraggableProductId(null));
};

export const initiateProductBuilderProgressLoading = ({
  id = 12345, // fake loader ID
  image = THUMBNAIL_PLACEHOLDER,
  name = 'Loader',
  fileUrl = null,
  shortProgress = true,
  progressTimes = [0, 0.75, 1.75, 2.75, 3.75, 4.99],
  initialProgress = 0,
  totalProgress = 5,
} = {}) => {
  dispatcher(paginatedProductActions.resetProgress());
  dispatcher(productBuilderActions.setBuilderLoading(false));

  let timerIds = []; // Array to store timeout IDs

  dispatcher(
    setDraggableProductImage({
      id,
      image,
      x: '50%',
      y: '50%',
    })
  );
  const data = {
    type: 'PropLibrary',
    id,
    propName: name,
    fileUrl,
  };
  dispatcher(setUnityDraggableProductData(data));

  if (shortProgress) {
    // initial with default value
    dispatcher(
      paginatedProductActions.setProgress({
        id,
        total: totalProgress,
        loaded: initialProgress,
      })
    );
  }

  // time in milliseconds
  progressTimes?.forEach((time) => {
    const timerId = setTimeout(
      () =>
        dispatcher(
          paginatedProductActions.setProgress({
            id,
            total: totalProgress,
            loaded: time,
          })
        ),
      time * 1000 // Convert seconds to milliseconds
    );
    timerIds.push(timerId); // Store the timeout ID
  });

  return timerIds;
};

export const downloadMattressPDF = async ({ getProjectThumbnail }) => {
  const productBuilderData = selectProductBuilderData(getAppState());
  if (!productBuilderData?.data?.json_file) {
    return;
  }
  const jsonData = await getProductBuilderJson({ ...productBuilderData });
  const selectionsData = jsonData?.selectionsData || {};
  if (isEmpty(selectionsData)) {
    return;
  }
  const data = convertToPdfFormat(jsonData?.selectionsData || {});
  const thumnail = getProjectThumbnail ? await getProjectThumbnail() : null;
  const imageUrl = URL.createObjectURL(thumnail);
  const blob = await pdf(<MattressPdf imageUrl={imageUrl} data={data} />).toBlob(); // Generate PDF as Blob
  const url = URL.createObjectURL(blob); // Create a URL for the Blob
  const a = document.createElement('a');
  a.href = url;
  a.download = `${productBuilderData.name}.pdf`; // Set the filename
  document.body.appendChild(a);
  a.click(); // Trigger download
  document.body.removeChild(a);
  URL.revokeObjectURL(url); // Cleanup
  URL.revokeObjectURL(imageUrl); // Cleanup
  mattressBtnClickEvents({ btnName: 'Download_Pdf' });
};

export const printMissingData = ({ type = '', list = [], properties = [] }) => {
  list.map((val) => {
    const propertyArr = [`name - ${val?.name}`];
    val?.product_property?.map((ins) => {
      const property = properties.find((prop) => prop.id === ins);
      if (property?.name) {
        propertyArr.push(`type - ${property?.name}`);
      }
    });
    if (propertyArr.length) {
      if (propertyArr?.length < 3) {
        propertyArr.push('type - missing');
      }
      LogConsole(`component: ${type}, ${propertyArr.join(', ')}`);
    }
  });
};

export const checkIsAllowedFromProperties = ({ data, checkCanAddAsAnotherTop = false } = {}) => {
  const allProperties = selectAllProperties(getAppState());
  const selectedSize = selectSelectedSize(getAppState());
  const productProperties = data?.product_property?.filter(
    (property) => parseInt(property) !== parseInt(selectedSize?.id)
  );
  const properties = allProperties?.filter((val) => productProperties?.includes(val?.id));
  if (properties?.length) {
    const isAllowed = properties?.some(
      (property) =>
        !property?.[checkCanAddAsAnotherTop ? 'can_add_as_another_top' : 'allow_multiple_component']
    );
    return !isAllowed;
  }
  return true;
};

export const deleteTuftedButtons = (data) => {
  window.productBuilderModule.DeleteTuftButtonConfiguration({
    tuftedButtonConfiguration: data,
  });
};

export const getTextureFieldsWithDefaultTexture = async (
  unityObjectInfoCombined,
  includeTexturePath
) => {
  const unityObjectInfo = unityObjectInfoCombined?.raw;
  let allTexturesData = [];
  let defaultTexture = false;
  let texturePaths = [];
  if (unityObjectInfo.isTexture) {
    let obj = { texturePath: 'diffuse' };
    if (!unityObjectInfo.isTextureChanged) {
      defaultTexture = true;
      obj['textureImage'] = unityObjectInfoCombined?.parsed?.texture?.mapImage;
      obj['textureType'] = 'Designs';
      obj['textureName'] = unityObjectInfo?.diffuseName;
      obj['height'] = unityObjectInfoCombined?.parsed?.texture?.height;
      obj['width'] = unityObjectInfoCombined?.parsed?.texture?.width;
      obj['mapChangeKey'] = 'isTextureChanged';
    }
    if (unityObjectInfo.changedMapsPath?.diffuseId || unityObjectInfo.diffuseId) {
      obj['id'] = unityObjectInfo.changedMapsPath?.diffuseId || unityObjectInfo.diffuseId;
    }
    allTexturesData.push(obj);
  }
  if (unityObjectInfo.isNormal) {
    let obj = { texturePath: 'normal' };
    if (!unityObjectInfo.isNormalMapChanged) {
      defaultTexture = true;
      obj['textureImage'] = unityObjectInfoCombined?.parsed?.normal?.mapImage;
      obj['textureType'] = 'Depth(Normal) Maps';
      obj['textureName'] = unityObjectInfo?.normalMapName;
      obj['height'] = unityObjectInfoCombined?.parsed?.normal?.height;
      obj['width'] = unityObjectInfoCombined?.parsed?.normal?.width;
      obj['mapChangeKey'] = 'isNormalMapChanged';
    }
    if (unityObjectInfo.changedMapsPath?.normalId || unityObjectInfo.normalId) {
      obj['id'] = unityObjectInfo.changedMapsPath?.normalId || unityObjectInfo.normalId;
    }
    allTexturesData.push(obj);
  }
  if (unityObjectInfo.isAOMap) {
    let obj = { texturePath: 'AO' };
    if (!unityObjectInfo.isAOMapChanged) {
      defaultTexture = true;
      obj['textureImage'] = unityObjectInfoCombined?.parsed?.ao?.mapImage;
      obj['textureType'] = 'AO Maps';
      obj['textureName'] = unityObjectInfo?.aoMapName;
      obj['height'] = unityObjectInfoCombined?.parsed?.ao?.height;
      obj['width'] = unityObjectInfoCombined?.parsed?.ao?.width;
      obj['mapChangeKey'] = 'isAOMapChanged';
    }
    if (unityObjectInfo.changedMapsPath?.aoId || unityObjectInfo.aoId || unityObjectInfo.AOId) {
      obj['id'] =
        unityObjectInfo.changedMapsPath?.aoId || unityObjectInfo.aoId || unityObjectInfo.AOId;
    }
    allTexturesData.push(obj);
  }
  if (unityObjectInfo.isRoughnessMap) {
    let obj = { texturePath: 'roughness' };
    if (!unityObjectInfo.isRoughnessMapChanged) {
      defaultTexture = true;
      obj['textureImage'] = unityObjectInfoCombined?.parsed?.glossiness?.mapImage;
      obj['textureType'] = 'Glossy Maps';
      obj['textureName'] = unityObjectInfo?.roughnessMapName;
      obj['height'] = unityObjectInfoCombined?.parsed?.glossiness?.height;
      obj['width'] = unityObjectInfoCombined?.parsed?.glossiness?.width;
      obj['mapChangeKey'] = 'isRoughnessMapChanged';
    }
    if (unityObjectInfo.changedMapsPath?.roughnessId || unityObjectInfo.roughnessId) {
      obj['id'] = unityObjectInfo.changedMapsPath?.roughnessId || unityObjectInfo.roughnessId;
    }
    allTexturesData.push(obj);
  }
  if (unityObjectInfo.isMetallicMap) {
    let obj = { texturePath: 'metallic' };
    if (!unityObjectInfo.isMetallicMapChanged) {
      defaultTexture = true;
      obj['textureImage'] = unityObjectInfoCombined?.parsed?.metallic?.mapImage;
      obj['textureType'] = 'Metallic Maps';
      obj['textureName'] = unityObjectInfo?.metallicMapName;
      obj['height'] = unityObjectInfoCombined?.parsed?.metallic?.height;
      obj['width'] = unityObjectInfoCombined?.parsed?.metallic?.width;
      obj['mapChangeKey'] = 'isMetallicMapChanged';
    }
    if (unityObjectInfo.changedMapsPath?.metallicId || unityObjectInfo.metallicId) {
      obj['id'] = unityObjectInfo.changedMapsPath?.metallicId || unityObjectInfo.metallicId;
    }
    allTexturesData.push(obj);
  }
  if (unityObjectInfo.isDisplacementMap) {
    let obj = { texturePath: 'displacement' };
    if (!unityObjectInfo.isDisplacementMapChanged) {
      defaultTexture = true;
      obj['textureImage'] = unityObjectInfoCombined?.parsed?.displacement?.mapImage;
      obj['textureType'] = 'Displacement Maps';
      obj['textureName'] = unityObjectInfo?.displacementMapName;
      obj['height'] = unityObjectInfoCombined?.parsed?.displacement?.height;
      obj['width'] = unityObjectInfoCombined?.parsed?.displacement?.width;
      obj['mapChangeKey'] = 'isDisplacementMapChanged';
    }
    if (unityObjectInfo.changedMapsPath?.displacementId || unityObjectInfo.displacementId) {
      obj['id'] = unityObjectInfo.changedMapsPath?.displacementId || unityObjectInfo.displacementId;
    }
    allTexturesData.push(obj);
  }
  if (unityObjectInfo.isTransparencyMap) {
    let obj = { texturePath: 'transparency' };
    if (!unityObjectInfo.isTransparencyMapChanged && !unityObjectInfo.transparencyMapName) {
      defaultTexture = true;
      obj['textureImage'] = unityObjectInfoCombined?.parsed?.transparency?.mapImage;
      obj['textureType'] = 'Transparency Maps';
      obj['textureName'] = unityObjectInfo?.transparencyMapName;
      obj['height'] = unityObjectInfoCombined?.parsed?.transparency?.height;
      obj['width'] = unityObjectInfoCombined?.parsed?.transparency?.width;
      obj['mapChangeKey'] = 'isTransparencyMapChanged';
    }
    if (unityObjectInfo.changedMapsPath?.transparencyId || unityObjectInfo.transparencyId) {
      obj['id'] = unityObjectInfo.changedMapsPath?.transparencyId || unityObjectInfo.transparencyId;
    }
    allTexturesData.push(obj);
  }
  if (includeTexturePath && allTexturesData?.length && !unityObjectInfo?.isInitialMaterialChanged) {
    await Promise.all(
      allTexturesData?.map(async (texData, ind) => {
        if (texData?.id) {
          const query = `id=${texData?.id}&ignore_lf_default=true&per_page=20&page=1`;
          const textures = await apiGetTextureList({ query });
          const texture = textures.results?.[0];
          const textureDbData = await updateDbTexture(texture);
          texturePaths.push({
            path: textureDbData.file,
            id: texData.id,
            field: texData.texturePath,
          });
        }
      })
    );
  }
  return { defaultTexture, allTexturesData, texturePaths };
};

export const getTexturePathsForUnityNoChangedMap = async (jsonData) => {
  const { texturePaths } = await getTextureFieldsWithDefaultTexture({ raw: jsonData }, true);
  const copyData = JSON.parse(JSON.stringify(jsonData));
  for (let i = 0; i < texturePaths?.length; i++) {
    copyData[texturePaths[i].field + 'Path'] = texturePaths[i].path;
  }
  return copyData;
};

export const updateViewAfterDeleteOrPasteMaterial = () => {
  const addedViewData = selectAddedViewData(getAppState());
  const selectionsData = selectSelectionsData(getAppState());
  const selectedView = addedViewData || selectionsData?.view || DEFAULT_VIEW;
  const gap = selectedView[`gap${selectedView?.view}`];
  changeMattressView({
    type: selectedView?.view,
    gap: selectedView?.view === 'exploded' ? (gap || 0) * 0.35 : gap || 0,
    isViewChangeUIClicked: true,
  });
};

export const focusOnButton = (data) => {
  window.productBuilderModule.FocusOnButtonConfigurationReceiver(data);
};

export const getLocationFromData = (sideLocation = '') => {
  const location = POSITION_DATA.find((val) => val.value === sideLocation);
  return location?.label || '';
};

export const getObjectPropertiesFromObjectName = async (objectName) => {
  const objectProperties = await waitForEventOnce(
    UnityEvent.OnReceiveMaterialPropertiesofGivenObject,
    (data) => {
      window.materialModule.SendMaterialPropertiesByObjectNameReceiver(objectName);
    }
  );
  return objectProperties;
};

export const isTuftCompatibleQuilt = ({ displacementId } = {}) => {
  const patternList = selectPatternList(getAppState()) || [];
  if (displacementId) {
    const data = patternList.find((val) => parseInt(val?.id) === parseInt(displacementId));
    const isPresent = data.filteroptions.find(
      (ins) => ins?.id === UPLOAD_MAP_TO_FILTER_ID[TILING_TYPE.TUFT_DISPLACEMENT]
    );
    return Boolean(isPresent);
  }
  return false;
};

export const updateDisplacementMapChanged = () => {
  PubSub.publish(UnityEvent.ReceiveDisplacementMapChanged);
};

export const updateDisplacementMapChangedWithCycle = async () => {
  updateDisplacementMapChanged(); // schedule event
  // Hook into the Unity event
  const promises = [
    waitForEventOnce(UnityEvent.OnHeightChangedForProductBuilder),
    waitForEventOnce(UnityEvent.ReceiveSelectedObjectInfo),
  ];
  await Promise.all(promises);
};

export const arrangeTuftButtonReceiverOnInternalLayerChange = () => {
  window.productBuilderModule.ArrangeTuftButtonReceiverOnInternalLayerChange();
};

export const onArrangeTufftedButtonReceiver = (data) => {
  window.productBuilderModule.OnArrangeTufftedButtonReceiver(data);
};

export const extractDimensions = (str) => {
  // Regex to find two numbers before "
  const matches = str.match(/(\d+)\s*"\s*[xX]\s*(\d+)\s*"/);
  if (matches) {
    const width = parseInt(matches[1], 10);
    const height = parseInt(matches[2], 10);
    return { width, height };
  }
  return null;
};

export const saveBuilderProject = async (getProjectThumbnail) => {
  dispatcher(productBuilderActions.setSaveBuilderProjectLoading(true));
  await updateRoomJson({ getProjectThumbnail });
  successToast('Project saved successfully!');
};

export const areButtonsSelected = () => {
  const allSelectedObjects = selectSelectedObjectList(getAppState());
  return allSelectedObjects?.length
    ? allSelectedObjects.every((val) =>
        val?.styleObjectDatas?.find(
          (ins) => ins?.type === startCase(TUFTED_BUTTON).replace(/\s/g, '')
        )
      )
    : false;
};

export const disableUnGroup = (flag = true) => {
  const allSelectedObjects = selectSelectedObjectList(getAppState());
  const materialNames = uniqBy(allSelectedObjects, 'materialName');
  return flag ? materialNames.length > 1 : materialNames.length < 2 || materialNames.length > 2;
};

export const toggleGroupUngroup = (flag = true) => {
  const anyObjectSelected = selectIsAnyObjectSelected(getAppState());
  if (!anyObjectSelected || disableUnGroup(flag) || !areButtonsSelected()) {
    return;
  }
  if (flag) {
    dispatcher(productBuilderActions.setGroupUngroupPopup(true));
  } else {
    window.materialModule.BreakMaterialOfSelectedObjects();
  }
};

export const disableButtonMeshRendererReceiver = (data) => {
  window.productBuilderModule.DisableButtonMeshRendererReceiver(data);
};

export const getPresetConfiguration = (data) => {
  window.productBuilderModule.GetPresetConfiguration(data);
};

export const modifyCutawayLayer = (cutawayObj) => {
  if (typeof window.ModifyCutawayLayer === 'function') {
    window.ModifyCutawayLayer(cutawayObj);
  }
};

export const enableGameObject = (data) => {
  window.productBuilderModule.EnableGameObject(data);
};

export const disableGameObject = (data) => {
  window.productBuilderModule.DisableGameObject(data);
};

export const selectObjectBeforeUndoRedo = async (objectName) => {
  if(!objectName){
    return true
  }
  const currentObjectName = selectSelectedObjectName(getAppState());
  if(currentObjectName === objectName){
    return true
  }else
  selectUnityObject({mainController:window.unityContext?.mainController ,name: objectName} )
  return true
}

export const getLocationSide = (type) => {
     switch (type) {
      case "RightCenter":
        return 'LeftCenter';
      case 'LeftCenter':
        return "RightCenter";
      case 'BackCenter':
        return 'ForwardCenter';
      case 'ForwardCenter':
        return 'BackCenter';
      default:
        return type
     } 
  }
